import React, {useEffect, useState} from 'react';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import '../../scss/create_new.scss';


function EntityContacts(props) {
    const {entityId} = props;
    const navigate = useNavigate();
    const [fiveContactsList, setFiveContactsList] = useState([]);
    const [contactsList, setContactsList] = useState([]);
    const [showAllContacts, setShowAllContacts] = useState(false);
    const [sortstate, setSort] = useState(false);
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })

    var contacts = showAllContacts ? contactsList : fiveContactsList;

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken == '') {
                navigate('/');
            } else {
                const endpoint =   `/api/contacts/list?entityId=${entityId}${sortValues.sortBy ? `&sortKey=${sortValues.sortBy}` : ''}${sortValues.sortType ? `&sortOrder=${sortValues.sortType}` : ''}`;
                getCommonResponse.GetDetailsWithToken(endpoint, accesstoken, (data) => {
                    if(data.status == 200) {
                        if(data.data.data.length <= 5) {
                            setFiveContactsList(data.data.data);
                            setContactsList(data.data.data);
                        } else {
                            var contacts = [];
                            for(var i = 0; i < 5; i++) {
                                contacts.push(data.data.data[i])
                            }
                            setFiveContactsList(contacts);
                            setContactsList(data.data.data);
                        }
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [sortstate])

    const showContacts = () => {
        setShowAllContacts(!showAllContacts);
    }

    const sortContacts = (dataset) => {
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortType === 'asc') {
            setSort(!sortstate);
        } else {
            setSort(!sortstate);
        }
    }

    const contactRedirection = (contactId) => {
        window.open(`/contacts/${contactId}/view`, "_blank")
    }

    return (
        <div id='contacts' className='contacts-section'>
            <div className='contacts-container'>
                <div className='contacts-left'>
                    <div className='contacts'>Contacts</div>
                    <div className='showing'>Showing { contacts && contacts.length } contacts of { contactsList && contactsList.length }</div>
                    { contactsList && contactsList.length > 5 &&
                        <div className='showall' onClick={showContacts}>{showAllContacts ? "Show Less" : "Show All"}</div>
                    }
                </div>
            </div>
            <div className='contacts-table'>
                <table>
                    <thead>
                        <tr className='heading-row'>
                            <th className='heading-data first-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>First Name</div>
                                    <div className='sort-arrows'>
                                        {
                                            !(sortValues.sortBy === 'FirstName' && sortValues.sortType === 'Ascending') && 
                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='FirstName' data-sort-type='Ascending' onClick={(e) => sortContacts(e.target.dataset)}></img>
                                        }
                                        {
                                            !(sortValues.sortBy === 'FirstName' && sortValues.sortType === 'Descending') && 
                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='FirstName' data-sort-type='Descending' onClick={(e) => sortContacts(e.target.dataset)}></img>
                                        }
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>Last Name</div>
                                    <div className='sort-arrows'>
                                    {
                                        !(sortValues.sortBy === 'LastName' && sortValues.sortType === 'Ascending') &&
                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='LastName' data-sort-type='Ascending' onClick={(e) => sortContacts(e.target.dataset)}></img>
                                    }
                                    {
                                        !(sortValues.sortBy === 'LastName' && sortValues.sortType === 'Descending') &&
                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='LastName' data-sort-type='Descending' onClick={(e) => sortContacts(e.target.dataset)}></img>
                                    }                                            
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>Brand</div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div className='heading-arrows'>
                                        <div>Email Id</div>
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div className='heading-arrows'>
                                        <div>Phone</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    {
                    contacts.length === 0 ? <p className="no-result">No results found</p> :
                        <tbody>
                            { contacts && contacts.length > 0 && contacts.map((item, index) => {
                                return (
                                    <tr className='details-list-row' key={index} onClick={() => contactRedirection(item.idContacts)}>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.firstName && item.firstName}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.lastName && item.lastName}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.brand && item.brand}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.email && item.email}</td>
                                        <td className='details-list-data' style={{minWidth: "200px"}}>{item.phoneNumber && item.phoneNumber}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    }   
                </table>
            </div>
        </div>
    );
}

export default EntityContacts;